import { useNavigate } from 'react-router-dom';
import styles from './MobileAdCard.module.css';
import type { Ad } from '../../types';

export interface MobileAdCardProps {
  ad: Ad;
  variant?: 'grid' | 'list';
  showStore?: boolean;
  onClick?: (ad: Ad) => void;
}

export const MobileAdCard: React.FC<MobileAdCardProps> = ({
  ad,
  variant = 'grid',
  showStore = true,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(ad);
    } else {
      navigate(`/ads/${ad.id}`);
    }
  };

  const hasSpecialOffer = ad.specialOffer && ad.specialOffer.length > 0;
  const salesCount = ad.viewCount || 0;
  const imageUrl = ad.imageUrls && ad.imageUrls.length > 0 ? ad.imageUrls[0] : null;

  return (
    <div
      className={`${styles.mobileAdCard} ${variant === 'list' ? styles['mobileAdCard--list'] : ''}`}
      onClick={handleClick}
    >
      <div className={styles.mobileAdCard__image}>
        {imageUrl ? (
          <img src={imageUrl} alt={ad.title} />
        ) : (
          <span className={styles.mobileAdCard__placeholder}>🚗</span>
        )}
        {ad.featured && (
          <span className={styles.mobileAdCard__featuredBadge}>精選</span>
        )}
      </div>

      <div className={styles.mobileAdCard__content}>
        {showStore && (
          <div className={styles.mobileAdCard__store}>
            <span className={styles.mobileAdCard__storeName}>
              {ad.storeName || '未知店家'}
            </span>
            {ad.featured && (
              <span className={styles.mobileAdCard__verifiedBadge}>✓</span>
            )}
          </div>
        )}

        <h3 className={styles.mobileAdCard__title}>{ad.title}</h3>

        {ad.description && (
          <p className={styles.mobileAdCard__summary}>{ad.description}</p>
        )}

        <div className={styles.mobileAdCard__meta}>
          {hasSpecialOffer && (
            <span className={styles.mobileAdCard__discount}>{ad.specialOffer}</span>
          )}
          <span className={styles.mobileAdCard__sales}>{salesCount}+人付款</span>
        </div>

        <div className={styles.mobileAdCard__footer}>
          <div className={styles.mobileAdCard__contact}>
            <span className={styles.mobileAdCard__phoneIcon}>📞</span>
            <span className={styles.mobileAdCard__phone}>{ad.phone || '未提供'}</span>
          </div>
          {hasSpecialOffer && (
            <span className={styles.mobileAdCard__promoTag}>促銷中</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileAdCard;
